import { useTick } from '@pixi/react';
import { useCallback, useEffect, useRef, useState } from 'react';
// TODO: Consider converting uses of this hook to use <AnimationContainer /> instead.
// See https://medium.com/@teh_builder/ref-objects-inside-useeffect-hooks-eb7c15198780
export function useFadeOutWithContainerRefCallback(delayMsBeforeFade, fadeDurationMs, valueToTriggerAnimationReset = 0) {
    const containerRef = useRef();
    const startTimestampMs = useRef();
    const [isAnimating, setIsAnimating] = useState(false);
    const [isDoneFadingOut, setIsDoneFadingOut] = useState(false);
    const animate = useCallback(() => {
        if (containerRef.current) {
            if (!startTimestampMs.current) {
                // not started
                return;
            }
            const nowMs = performance.now();
            const fadeStartTimestampMs = startTimestampMs.current + delayMsBeforeFade;
            if (nowMs < fadeStartTimestampMs) {
                return;
            }
            const fadeElapsedMs = nowMs - fadeStartTimestampMs;
            const alpha = Math.max(0, 1 - fadeElapsedMs / fadeDurationMs);
            containerRef.current.alpha = alpha;
            if (alpha <= 0) {
                // done fading out
                setIsAnimating(false);
                setIsDoneFadingOut(true);
            }
        }
    }, [delayMsBeforeFade, fadeDurationMs]);
    const setContainerRef = useCallback((container) => {
        if (container) {
            container.alpha = 1;
            startTimestampMs.current = performance.now();
            setIsAnimating(true);
        }
        else {
            setIsAnimating(false);
        }
        containerRef.current = container;
    }, []);
    useEffect(() => {
        // reset animation
        startTimestampMs.current = performance.now();
        if (containerRef.current) {
            containerRef.current.alpha = 1;
        }
        setIsDoneFadingOut(false);
        setIsAnimating(true);
        return () => {
            setIsAnimating(false);
        };
    }, [animate, valueToTriggerAnimationReset]);
    useTick(animate, isAnimating);
    return [setContainerRef, isDoneFadingOut];
}
